import { generateUUID, type UUID } from "@perceptron/utils/crypto";
import { create } from "zustand";

interface SessionStore {
  sessionUuid: UUID;
  setSessionUuid: (sessionUuid: UUID) => void;
}

const useSessionStore = create<SessionStore>((set) => ({
  sessionUuid: generateUUID(),
  setSessionUuid: (sessionUuid: UUID) => set({ sessionUuid }),
}));

export default useSessionStore;
